import { Component, HostBinding, Input } from '@angular/core';
import { Theme } from 'studio-components';

@Component({
  selector: 'studio-form-label',
  templateUrl: './form-label.component.html',
  styleUrls: ['./form-label.component.scss'],
})
export class FormLabelComponent {
  @HostBinding('class')
  @Input()
  public theme: Theme = 'light';
  @Input() public for: string;
  @Input() public text: string;
  @Input() public isHidden = false;
  @Input() public helperText: string;
  @Input() public isRequiredField = false;
}
